import { TabPermission } from 'src/app/core/interfaces/permissions';
import { Administrative } from 'src/permissions/product-lines/administrative/administrative.setup';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';

const parent = Administrative.pages.usersRoles;
const path = 'users';
const title = 'PAGE.USERS_ROLES.USERS.TITLE';
const res = [
  'addUser',
  'actions',
  'actions.changeRole',
  'actions.deactivate',
  'actions.resendInvite',
  'actions.activate',
];

export const UsersRolesUsersTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
